<template>
    <modal v-model="show" size="md" :title="trans('general.page.space_forms.messages.share_form_by_link')">
        <share-form-by-link @success="handleSuccess" v-model="model"></share-form-by-link>
    </modal>
</template>

<script>
import FormInputBuilder from "../../../theme/molecules/FormInputBuilder.vue";
import Modal from "../../../theme/organisms/Modal.vue";
import ShareFormByLink from "../molecules/ShareFormByLink.vue";

export default {
    name: "ShareModal",
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    components: {
        ShareFormByLink,
        FormInputBuilder,
        Modal
    },
    watch: {
        model: {
            handler() {
                this.$emit('input', this.model)
            },
            deep: true
        }
    },
    data() {
        return {
            fields: [],
            model: this.value,
            errors: {},
            show: false,
        }
    },
    methods: {
        open() {
            this.show = true
        },
        handleSuccess(event) {
            this.$emit('close');
        },
    }
}
</script>
